import React, { useEffect } from "react";
import { connect } from "react-redux";
import { DataTypes } from "../../../../constants";
import { useHistory, useLocation } from "react-router";

import { Container, Grid, Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import CourseCard from "./CourseCard";
import Fetching from "../../../Common/Fetching";
import SearchField from "../../../Common/SearchField";

import tmsActions from "../../../../actions/tmsActions";
import { getCourses, isFetching } from "../../../../reducers";

const appCode = "C-TMS";

function CourseList({ courses = [], isFetching, getCourses }) {
    const history = useHistory();
    const location = useLocation();
    const queryString = new URLSearchParams(location.search);
    const searchString = queryString.get("q");

    useEffect(() => {
        const params = !!searchString ? { searchString } : null;
        getCourses(appCode, params);
    }, [getCourses, searchString]);

    const onSearch = (q) => getCourses(appCode, { searchString: q });
    const onClearSearch = () => {
        getCourses(appCode);
        if (!!searchString) {
            history.replace("/tms/courses");
        }
    };

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" to="/">
                                Home
                            </Link>
                            <Link underline="hover" color="inherit" to="/tms">
                                Training
                            </Link>
                            <Link
                                underline="hover"
                                color="inherit"
                                to="/tms/library"
                            >
                                Library
                            </Link>
                            <Typography color="text.primary">
                                Courses
                            </Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <SearchField
                        onSearch={onSearch}
                        onClear={onClearSearch}
                        label="Search courses"
                        placeholder="Search courses"
                        searchText={searchString || null}
                    />
                </Grid>
                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}
                {!!courses &&
                    !!courses.length &&
                    courses.map((course, index) => (
                        <Grid
                            item
                            lg={12}
                            xl={6}
                            key={index}
                            className="card-grid-item"
                        >
                            <CourseCard course={course} />
                        </Grid>
                    ))}
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    courses: getCourses(state),
    isFetching: isFetching(state, DataTypes.TMS_COURSES),
});

const mapDispatchToProps = {
    getCourses: tmsActions.getCourses,
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseList);
